export default __webpack_public_path__ + "static/media/8.db4f07a9.png";